/* eslint-disable linebreak-style */
/* eslint-disable camelcase */
/* eslint-disable no-undef */
import isBrowser from 'utils/isBrowser';

export function trackAsyncPV(adobeTagManager) {
  if (isBrowser() && adobeTagManager && typeof dtm_trackAsyncPV === 'function') {
    dtm_trackAsyncPV({ destinationURL: window.location.href });
  }
}
